<template>
  <div>
    <div class="mb-8 flex flex-col md:flex-row justify-between md:items-center bg-white">
      <div class="flex flex-col">
        <div class="flex items-center leading-none">
          <span class="mr-2 text-xl" v-text="event.title" v-if="event.title.length > 0"></span>
          <span class="mr-2 text-xl text-gray-300" v-else>Neue Veranstaltung</span>
          <span>
            <event-status-badge class="text-sm px-2 uppercase" status="draft"></event-status-badge>
          </span>
        </div>
      </div>
    </div>

    <div class="rounded-md bg-red-50 p-4 mb-10" v-if="hasErrors">
      <div class="flex">
        <div class="flex-shrink-0">
          <font-awesome-icon class="text-red-400" :icon="['fad', 'times-circle']" />
        </div>
        <div class="ml-3">
          <h3 class="text-sm leading-5 font-medium text-red-800">Es sind Fehler aufgetreten.</h3>
          <div class="mt-2 text-sm leading-5 text-red-700">
            <ul class="list-disc pl-5">
              <li v-for="(error, key) in errors" :key="key" class="mt-1">{{error[0]}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!initialLoading">
      <event-editor :errors="errors" :event="event" />

      <div
        class="p-4 mt-10 ml-auto md:w-2/3 rounded-lg shadow-xl border border-gray-200 bg-white flex justify-between items-center bottom-10 sticky"
      >
        <div
          class="text-gray-800 text-sm"
        >Nach dem Anlegen der Veranstaltung kann diese veröffentlicht werden.</div>
        <basic-button
          @click="store"
          :disabled="loading"
          :loading="loading"
          color="green"
          leading-icon="check"
        >Anlegen</basic-button>
      </div>
    </div>
  </div>
</template>

<script>
import EventHeader from "@/components/EventHeader";
import EventEditor from "@/components/editor/EventEditor";
import EventStatusBadge from "@/components/EventStatusBadge";

import eventsClient from "@/api/central/events";
import ticketFeesClient from "@/api/central/ticket-fees";

import _cloneDeep from "lodash/cloneDeep";
import _isEmpty from "lodash/isEmpty";

export default {
  components: {
    EventHeader,
    EventEditor,
    EventStatusBadge
  },

  data() {
    return {
      event: {
        title: "",
        description: "",
        start_date: {
          utc: null
        },
        end_date: {
          utc: null
        },
        categories: [],
        genre_id: null,
        header_id: null,
        logo_id: null,
        subgenre_id: null,
        venue_id: null,
        media: {
          header: {},
          logo: {}
        },
        ticket_fees: []
      },
      loading: false,
      initialLoading: true,
      errors: {}
    };
  },

  computed: {
    hasErrors() {
      return !_isEmpty(this.errors);
    }
  },

  mounted() {
    this.getTicketFees();
  },

  methods: {
    getTicketFees() {
      ticketFeesClient.show().then(({ data }) => {
        this.$set(this.event, "ticket_fees", data.data);

        this.initialLoading = false;
      });
    },
    store() {
      this.loading = true;
      this.errors = {};

      eventsClient
        .store(this.event)
        .then(({ data }) => {
          this.$toasted.global.saved();

          this.$router.push({
            name: "events.details",
            params: { id: data.data.id }
          });
        })
        .catch(error => {
          this.errors = error.response.data.errors;

          this.$toasted.global.error();
        })
        .then(() => (this.loading = false));
    }
  }
};
</script>